<footer id="footer" class="footer" [attr.tabindex]="tabindex" *ngIf="isFooter">
  <app-footer-link></app-footer-link>
  <div class="footer-itau">
    <span class="title itau-text-bold" [attr.tabindex]="tabindex">Itaú Unibanco S.A. (CNPJ 60.701.190/0001-04)</span><br />
    <span class="title" [attr.tabindex]="tabindex"  (focusout)="goToHeader()">Av. Brigadeiro Faria Lima, 3400 – 8º Andar. Cep 04538-132, São Paulo - SP</span>  </div>
</footer>